import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { AppModal } from "@/shared/Components";
import { TrashBinIcon } from "@/shared/icons";
import type { FC } from "react";
import type { Person } from "@/services/api";
import { Form } from "../Form";
import { Content } from "../Content";
import { deleteConnectionSchema } from "../../model/schema";
import styles from "./styles.module.scss";

type Props = {
  isModalOpen: boolean;
  defaultValues: Person["personConnections"];
  onCancel: () => void;
  onSubmit: (deletedNotes: Person["personConnections"]) => void;
};

export const ModalDeleteConnection: FC<Props> = ({
  isModalOpen,
  onCancel,
  onSubmit,
  defaultValues,
}) => {
  const { t } = useTranslation();
  const formApi = useForm({
    values: {
      connections: defaultValues.map((item) => ({ connection: item, selected: true })),
    },
    resolver: yupResolver(deleteConnectionSchema),
  });
  const deleteIsDisabled = !formApi.watch("connections")?.filter((item) => item.selected).length;
  return (
    <AppModal
      modalRender={(modal) => (
        <Form formApi={formApi} defaultValues={defaultValues} onSubmit={onSubmit}>
          {modal}
        </Form>
      )}
      className={styles.root}
      title={t("contactsPage.deleteConnection")}
      okButtonProps={{
        htmlType: "submit",
        className: styles["delete-button"],
        disabled: deleteIsDisabled,
        icon: <TrashBinIcon className={styles.icon} />,
      }}
      okText={t("common.delete")}
      cancelText={t("common.cancel")}
      onCancel={onCancel}
      open={isModalOpen}
    >
      <Content />
    </AppModal>
  );
};
